export const FETCH_PROJECT_TYPES = 'FETCH_PROJECT_TYPES';